import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {

  getStudents as getStudentsApi,
  addNewStudent as addNewStudentApi,
  updateStudent as updateStudentApi,
  deleteStudent as deleteStudentApi,
  importStudentFile as importStudentFileApi,
  approveExamReattempt as approveExamReattemptApi,

} from "../../helpers/custom_helper/backend_helper";

export const updateStudent = createAsyncThunk("update-student", async (student) => {
  try {
    const response = addNewStudentApi(student);
    const data = await response;
    if (data.success) {
      toast.success(data.message, { autoClose: 3000 });
      return data;
    } else {
      toast.error(data.message, { autoClose: 3000 });
      return data;
    }
  } catch (error) {
    toast.error("Student Updated Failed", { autoClose: 3000 });
    return error;
  }
});

export const addNewStudent = createAsyncThunk("save-student", async (student) => {
  try {
    const response = addNewStudentApi(student);
    const data = await response;
    if (data.success) {
      toast.success(data.message, { autoClose: 3000 });
      return data;
    } else {
      toast.error(data.message, { autoClose: 3000 });
      return data;
    }
  } catch (error) {
    toast.error("Student Added Failed", { autoClose: 3000 });
    return error;
  }
});

export const getStudents = createAsyncThunk("get-students", async (scope = 'mcd') => {
  try {
    const response = getStudentsApi(scope);
    const data = await response;
    if (data.success) {
      return response;
    } else {
      toast.error(data.message, { autoClose: 3000 });
    }
  } catch (error) {
    toast.error("Something wrong", { autoClose: 3000 });
    return error;
  }
});

export const deleteStudent = createAsyncThunk("delete-student", async (student) => {
  try {
    const response = deleteStudentApi(student);
    const data = await response;
    if (data.success) {
      toast.success(data.message, { autoClose: 3000 });
      return { student, ...response }
    } else {
      toast.error(data.message, { autoClose: 3000 });
      return response;
    }

  } catch (error) {
    toast.error("Student Deleted Failed", { autoClose: 3000 });
    return error;
  }
});

export const approveExamReattempt = createAsyncThunk("approve-exam-reattempt", async ({ studentId, scope = 'mcd', courseId = null }, { dispatch }) => {
  try {
    const payload = { student_id: studentId, scope };
    if (courseId) {
      payload.course_id = courseId;
    }
    const response = approveExamReattemptApi(payload);
    const data = await response;
    if (data.success) {
      toast.success(data.message, { autoClose: 3000 });
      dispatch(getStudents(scope));
      return data;
    } else {
      toast.error(data.message, { autoClose: 3000 });
      return data;
    }
  } catch (error) {
    toast.error("Failed to approve exam reattempt", { autoClose: 3000 });
    return error;
  }
});

export const importStudent = createAsyncThunk("import-student", async (student) => {
  try {
    const response = importStudentFileApi(student);
    const data = await response;
    if (data.success) {
      toast.success(data.message, { autoClose: 3000 });
      return data;
    } else {
      toast.error(data.message, { autoClose: 3000 });
      return data;
    }
  } catch (error) {
    toast.error("Student Import Failed", { autoClose: 3000 });
    return error;
  }
});